import { render, staticRenderFns } from "./interaction.vue?vue&type=template&id=3f5f209a&scoped=true"
import script from "./interaction.vue?vue&type=script&lang=js"
export * from "./interaction.vue?vue&type=script&lang=js"
import style0 from "./interaction.vue?vue&type=style&index=0&id=3f5f209a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f209a",
  null
  
)

export default component.exports